import moment from 'moment';

export type IqAggregatedTimePreset = '1d' | '1w' | '2w' | '1m';

export interface IqAggregatedTimeRange {
  begin: string; // ISO-8601 UTC
  end: string; // ISO-8601 UTC
}

const PRESET_SUBTRACT: Record<
  IqAggregatedTimePreset,
  [number, moment.unitOfTime.DurationConstructor]
> = {
  '1d': [24, 'hours'],
  '1w': [7, 'days'],
  '2w': [14, 'days'],
  '1m': [1, 'months'],
};

export function getIqAggregatedTimeRange(
  preset: IqAggregatedTimePreset,
  now = moment.utc(),
): IqAggregatedTimeRange {
  const end = now.toISOString();
  const [amount, unit] = PRESET_SUBTRACT[preset];
  const begin = moment.utc(now).subtract(amount, unit).toISOString();
  return { begin, end };
}
